export default __webpack_public_path__ + "static/media/grant.31d67a66.mp3";